import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { MiGenParameters } from 'src/app/model/MiGenParameters';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';

@Component({
  selector: 'ms-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {

  public cmsObj: CmsObject[];
  language: string;
  public title1:string;
  public content1:string;
  public title2:string;
  public content2:string;
  public title3:string;
  public content3:string;
  public showNews1: boolean;
  public showNews2: boolean;
  public showNews3: boolean;




  constructor(
    private router: Router,
    private workFlow: WorkFlowService,
    public cmsService: CmsService,
    public navigateService: NavigateService,
    private serviceUtilsService: ServiceUtilsService) { }

  async  ngOnInit(){
    let opRes1 = await this.serviceUtilsService.getStoreParameterValue('newsDashboard_1');
    let content1_Disabled = new MiGenParameters();
    content1_Disabled = opRes1.Content as MiGenParameters;

    let opRes2 = await this.serviceUtilsService.getStoreParameterValue('newsDashboard_2');
    let content2_Disabled = new MiGenParameters();
    content2_Disabled = opRes2.Content as MiGenParameters;

    let opRes3 = await this.serviceUtilsService.getStoreParameterValue('newsDashboard_3');
    let content3_Disabled = new MiGenParameters();
    content3_Disabled = opRes3.Content as MiGenParameters;

    this.showNews1 = !content1_Disabled.Disabled ;
    this.showNews2 = !content2_Disabled.Disabled ;
    this.showNews3 = !content3_Disabled.Disabled ;

    await this.getCmsObj();



  }


async getCmsObj() {
  this.language = this.workFlow.getLanguageForCms();
  //recupero le stringhe della pagina
  this.cmsObj = await this.cmsService.getCmsObj(this.language, 'News');
  this.content1 = this.cmsObj.find((x) => x.ContentName == 'News.Products.001_Descri').ContentTranslation;
  this.title1 = this.cmsObj.find((x) => x.ContentName == 'News.Products.001_Title').ContentTranslation;

  this.content2 = this.cmsObj.find((x) => x.ContentName == 'News.Products.002_Descri').ContentTranslation;
  this.title2 = this.cmsObj.find((x) => x.ContentName == 'News.Products.002_Title').ContentTranslation;

  this.content3 = this.cmsObj.find((x) => x.ContentName == 'News.Products.003_Descri').ContentTranslation;
  this.title3 = this.cmsObj.find((x) => x.ContentName == 'News.Products.003_Title').ContentTranslation;






}
}
